/** Route table: lazy-loaded views for code splitting */
export const constantRouterMap = [
    {
        path: '/',
        name: 'login',
        component: () => import("../views/index/login.vue")
    },
    {
        path: '/personal',
        name: 'personal',
        component: () => import("../components/conme/personal.vue")
    },
    {
        path: '/daping',
        name: 'daping',
        component: () => import("../views/daping/daping.vue")
    },
    {
        path: '/displayLarge',
        name: 'displayLarge',
        component: () => import("../views/displayLarge/displayLarge.vue")
    },
    {
        path: '/index',
        name: 'index',
        component: () => import("../views/layout/index.vue"),
        redirect: '/home',
        children: [{
            path: '/home',
            name: 'home',
            component: () => import("../views/index/homepage.vue")
        },
            {
                path: "/404",
                name: "page404",
                meta: {
                    hidden: true
                },
                component: () => import("@/views/error-page/404.vue")
            },
            {
                path: "/:pathMatch(.*)*",
                redirect: '/404'
            },
            {
                path: "/401",
                name: "page401",
                meta: {
                    hidden: true
                },
                component: () => import("@/views/error-page/401.vue")
            },


            {
                path: '/mopaws',
                name: 'mopaws',
                component: () => import("../views/index/mopaws.vue")
            },
            {
                path: '/mophone',
                name: 'mophone',
                component: () => import("../views/index/mophone.vue")
            },
            {
                path: '/role',
                name: 'role',
                component: () => import("../views/permission/role_mage.vue")
            },
            {
                path: '/power',
                name: 'power',
                component: () => import("../views/permission/power_list.vue")
            },
            {
                path: '/addpower',
                name: 'addpower',
                redirect: '/power'
            },
            {
                path: '/table_column_defaults',
                name: 'table_column_defaults',
                component: () => import("../views/permission/table_column_defaults.vue")
            },
            {
                path: '/daily_mail_resend',
                name: 'daily_mail_resend',
                meta: { superAdminOnly: true },
                component: () => import("../views/permission/daily_mail_resend.vue")
            },
            {
                path: '/Editing',
                name: 'Editing',
                component: () => import("../components/conme/Editing.vue")
            },
            {
                path: '/role_editor',
                name: 'role_editor',
                component: () => import("../components/conme/role_editor.vue")
            },
            {
                path: '/backuser',
                name: 'backuser',
                component: () => import("../views/backuser/backuser.vue")
            },
            {
                path: '/putstorage',
                name: 'putstorage',
                component: () => import("../views/information/putstorage.vue")
            },
            {
                path: '/outbound',
                name: 'outbound',
                component: () => import("../views/information/outbound.vue")
            },
            {
                path: '/points',
                name: 'points',
                component: () => import("../views/information/Points.vue")
            },
            {
                path: '/machine',
                name: 'machine',
                component: () => import("../views/permission/machine.vue")
            },
            {
                path: '/tooling_product_list',
                name: 'tooling_product_list',
                component: () => import("../views/permission/tooling_product_list.vue")
            },
            {
                path: '/ad_plan',
                name: 'ad_plan',
                component: () => import("../views/permission/ad_plan.vue")
            },
            {
                path: '/payee',
                name: 'payee',
                component: () => import("../views/permission/payee.vue")
            },
            {
                path: '/payee_o',
                name: 'payee_o',
                component: () => import("../views/permission/payee_o.vue")
            },
            {
                path: '/pay_code',
                name: 'pay_code',
                component: () => import("../views/permission/pay_code.vue")
            },
            {
                path: '/wxxcx',
                name: 'wxxcx',
                component: () => import("../views/permission/wxxcx.vue")
            },
            {
                path: '/coupon',
                name: 'coupon',
                component: () => import("../views/permission/coupon.vue")
            },
            {
                path: '/couponIssuance',
                name: 'couponIssuance',
                component: () => import("../views/permission/couponIssuance.vue")
            },

            {
                path: '/set_meal',
                name: 'set_meal',
                component: () => import("../views/permission/set_meal.vue")
            },

            {
                path: '/version',
                name: 'version',
                component: () => import("../views/permission/version.vue")
            },

            {
                path: '/wechat_official_account',
                name: 'wechat_official_account',
                component: () => import("../views/permission/wechat_official_account.vue")
            },
            {
                path: '/ad_plan_d',
                name: 'ad_plan_d',
                component: () => import("../views/permission/ad_plan.vue")
            },
            {
                path: '/jiqidetails',
                name: 'jiqidetails',
                component: () => import("../views/jiqidetails/jiqidetails.vue")
            },
            {
                path: '/orderdetails',
                name: 'orderdetails',
                component: () => import("../views/orderdetails/orderdetails.vue")
            },
            {
                path: '/matype',
                name: 'matype',
                component: () => import("../views/permission/matype.vue")
            },
            {
                path: '/machaisle',
                name: 'machaisle',
                component: () => import("../views/machaisle/machaisle.vue")
            },
            {
                path: '/road_template',
                name: 'road_template',
                component: () => import("../views/permission/road_template.vue")
            },
            {
                path: '/road_his',
                name: 'road_his',
                component: () => import("../views/permission/road_his.vue")
            },
            {
                path: '/box_his',
                name: 'box_his',
                component: () => import("../views/permission/box_his.vue")
            },
            {
                path: '/box_weight_session',
                name: 'box_weight_session',
                component: () => import("../views/permission/box_weight_session.vue")
            },

            {
                path: '/alteration',
                name: 'alteration',
                component: () => import("../views/machaisle/alteration.vue")
            },
            {
                path: '/advertising',
                name: 'advertising',
                component: () => import("../views/permission/advertising.vue")
            },
            {
                path: '/machineadver',
                name: 'machineadver',
                component: () => import("../views/permission/Machineadver.vue")
            },
            {
                path: '/goods',
                name: 'goods',
                component: () => import("../views/permission/goods.vue")
            },
            {
                path: '/item_code',
                name: 'item_code',
                component: () => import("../views/permission/item_code.vue")
            },
            {
                path: '/hangar',
                name: 'hangar',
                component: () => import("../views/permission/hangar.vue")
            },
            {
                path: '/classify',
                name: 'classify',
                component: () => import("../views/permission/classify.vue")
            },
            {
                path: '/brand',
                name: 'brand',
                component: () => import("../views/permission/brand.vue")
            },
            {
                path: '/userorder',
                name: 'userorder',
                component: () => import("../views/permission/userorder.vue")
            },
            {
                path: '/userorder_grant',
                name: 'userorder_grant',
                component: () => import("../views/permission/userorder_grant.vue")
            },    
            {
                path: '/orderReceive',
                name: 'orderReceive',
                component: () => import("../views/permission/orderReceive.vue")
            },
            {
                path: '/material',
                name: 'material',
                component: () => import("../views/material/materialList.vue")
            },
            {
                path: '/orderFormMaterialList',
                name: 'orderFormMaterialList',
                component: () => import("../views/orderForm/orderFormMaterialList.vue")
            },
            {
                path: '/separateAccountList',
                name: 'separateAccountList',
                component: () => import("../views/separate/separateAccountList.vue")
            },
            {
                path: '/appletUserList',
                name: 'appletUserList',
                component: () => import("../views/applet/appletUserList.vue")
            },
            {
                path: '/productRfidList',
                name: 'productRfidList',
                component: () => import("../views/rfid/productRfidList.vue")
            },
            {
                path: '/rfid_cabinet_config',
                name: 'rfid_cabinet_config',
                redirect: '/machine'
            },
            {
                path: '/rfid_cabinet_session',
                name: 'rfid_cabinet_session',
                component: () => import("../views/rfid/rfidCabinetSession.vue")
            },
            {
                path: '/separateSettingList',
                name: 'separateSettingList',
                component: () => import("../views/separate/separateSettingList.vue")
            },
            {
                path: '/separateVerifyList',
                name: 'separateVerifyList',
                component: () => import("../views/separate/separateVerifyList.vue")
            },
            {
                path: '/separateDetailsList',
                name: 'separateDetailsList',
                component: () => import("../views/separate/separateDetailsList.vue")
            },
            {
                path: '/customerOptions',
                name: 'customerOptions',
                component: () => import("../views/material/customerOptions.vue")
            },
            {
                path: '/materialCategory',
                name: 'materialCategory',
                component: () => import("../views/material/categoryList.vue")
            },
            {
                path: '/taste',
                name: 'taste',
                component: () => import("../views/taste/tasteList.vue")
            },
            {
                path: '/tasteCategory',
                name: 'tasteCategory',
                component: () => import("../views/taste/categoryList.vue")
            },
            {
                path: '/mac_materials',
                name: 'mac_materials',
                component: () => import("../views/permission/mac_materials.vue")
            },
            {
                path: '/productalertlog',
                name: 'productalertlog',
                component: () => import("../views/permission/productalertlog.vue")
            },
            {
                path: '/orderReceiveUseLog',
                name: 'orderReceiveUseLog',
                component: () => import("../views/permission/orderReceiveUseLog.vue")
            },
            {
                path: '/userorder_box',
                name: 'userorder_box',
                component: () => import("../views/permission/userorder_box.vue")
            },
            {
                path: '/userorder_box_statistics',
                name: 'userorder_box_statistics',
                component: () => import("../views/permission/userorder_box_statistics.vue")
            },
            {
                path: '/salesStatistics',
                name: 'salesStatistics',
                component: () => import("../views/permission/salesStatistics.vue")
            },
            {
                path: '/salesStatisticsbymac',
                name: 'salesStatisticsbymac',
                component: () => import("../views/permission/salesStatisticsbymac.vue")
            },
            {
                path: '/userorder_borrow_mac_product',
                name: 'userorder_borrow_mac_product',
                component: () => import("../views/permission/userorder_borrow_mac_product.vue")
            },
            
            {
                path: '/machine_statistics',
                name: 'machine_statistics',
                component: () => import("../views/permission/machine_statistics.vue")
            },

            {
                path: '/userorder_total',
                name: 'userorder_total',
                component: () => import("../views/permission/userorder_total.vue")
            },
            {
                path: '/lathe',
                name: 'lathe',
                component: () => import("../views/permission/lathe.vue")
            },

            {
                path: '/mac_statistics',
                name: 'mac_statistics',
                component: () => import("../views/permission/mac_statistics.vue")
            },
            {
                path: '/chart_mac',
                name: 'chart_mac',
                component: () => import("../views/chart/chart_mac.vue")
            },
            {
                path: '/chart_personal',
                name: 'chart_personal',
                component: () => import("../views/chart/chart_personal.vue")
            },

            {
                path: '/blinkboxorder',
                name: 'blinkboxorder',
                component: () => import("../views/permission/blinkboxorder.vue")
            },
            {
                path: '/blinkboxorderwithdrawal',
                name: 'blinkboxorderwithdrawal',
                component: () => import("../views/permission/blinkboxorderwithdrawal.vue")
            },

            {
                path: '/pickup_code',
                name: 'pickup_code',
                component: () => import("../views/permission/pickup_code.vue")
            },
            {
                path: '/userlist',
                name: 'userlist',
                component: () => import("../views/permission/userlist.vue")
            },
            {
                path: '/userlist_worker',
                name: 'userlist_worker',
                component: () => import("../views/permission/userlist_worker.vue")
            },
            {
                path: '/workflow_type',
                name: 'workflow_type',
                component: () => import("../views/permission/workflow_type.vue")
            },

            {
                path: '/reimburse',
                name: 'reimburse',
                component: () => import("../views/financial/reimburse.vue")
            },
            {
                path: '/marketsum',
                name: 'marketsum',
                component: () => import("../views/financial/marketsum.vue")
            },
            {
                path: '/particulars',
                name: 'particulars',
                component: () => import("../views/financial/particulars.vue")
            },
            {
                path: '/supplier',
                name: 'supplier',
                component: () => import("../views/supplier/supplier.vue")
            },
            {
                path: '/shipment',
                name: 'shipment',
                component: () => import("../views/supplier/shipment.vue")
            },
            {
                path: '/shment',
                name: 'shment',
                component: () => import("../views/supplier/shment.vue")
            },
            {
                path: '/summary',
                name: 'summary',
                component: () => import("../views/supplier/summary.vue")
            },
            {
                path: '/replenis',
                name: 'replenis',
                component: () => import("../views/supplier/replenis.vue")
            },
            {
                path: '/pre_replenishment',
                name: 'pre_replenishment',
                component: () => import("../views/supplier/preReplenishment.vue")
            },
            {
                path: '/warehouse',
                name: 'warehouse',
                component: () => import("../views/warehouse/warehouse.vue")
            },
            {
                path: '/warehouse_reper',
                name: 'warehouse_reper',
                component: () => import("../views/warehouse/warehouse_reper.vue")
            },
            {
                path: '/warehouse_change',
                name: 'warehouse_change',
                component: () => import("../views/warehouse/warehouse_change.vue")
            },
            {
                path: '/signing',
                name: 'signing',
                component: () => import("../views/signing/signing.vue")
            },
            {
                path: '/contract',
                name: 'contract',
                component: () => import("../views/signing/contract.vue")
            },
            {
                path: '/tissue',
                name: 'tissue',
                component: () => import("../views/tissue/tissue.vue")
            },
            {
                path: '/common',
                name: 'common',
                component: () => import("../views/repairs/common.vue")
            },
            {
                path: '/repafault',
                name: 'repafault',
                component: () => import("../views/repairs/repafault.vue")
            },
            {
                path: '/check',
                name: 'check',
                component: () => import("../views/repairs/check.vue")
            },
            {
                path: '/reports',
                name: 'reports',
                component: () => import("../views/reports/index.vue")
            },
            {
                path: '/business',
                name: 'business',
                component: () => import("../views/reports/business.vue")
            },
            {
                path: '/machinsales',
                name: 'machinsales',
                component: () => import("../views/reports/machinsales.vue")
            },
            {
                path: '/volume',
                name: 'volume',
                component: () => import("../views/reports/volume.vue")
            },
            {
                path: '/cabinetorder',
                name: 'cabinetorder',
                component: () => import("../views/financial/cabinetorder.vue")
            },
            {
                path: '/storage',
                name: 'storage',
                component: () => import("../views/setting/storage/index.vue")
            },
        ]
    }
]
